// src/pages/LiveChat.js
import React from 'react';
import '../styles/live-chat.css'; // Ensure this path is correct
import { useNavigate } from "react-router-dom";

function LiveChat() {
    const navigate = useNavigate();

    return (
        <div className="live-page">
            <div className="live-content">
                <div className="chat-bubble-header"></div>
                <div className="live-text-content">
                    <h1>LIVE CHAT WITH OUR SUPPORT</h1>
                    <p className="live-text">
                        Need assistance? Our support team is here to help! Feel free to start a live chat with us and get your questions answered.
                    </p>
                    <button className="start-chat-btn" onClick={() => navigate('/admin-chat')}>START CHAT</button>
                </div>
            </div>
        </div>
    );
}

export default LiveChat;